var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.7999 47.6668C37.2783 47.6668 45.7727 39.252 45.7727 28.8717C45.7727 18.4915 37.2783 10.0767 26.7999 10.0767C16.3215 10.0767 7.82715 18.4915 7.82715 28.8717C7.82715 39.252 16.3215 47.6668 26.7999 47.6668Z",
    fill: "#007f6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7988 18.9521C27.672 18.9521 28.3799 19.6534 28.3799 20.5184V28.223L33.187 32.9851C33.8045 33.5968 33.8045 34.5885 33.187 35.2002C32.5696 35.8118 31.5685 35.8118 30.9511 35.2002L25.6809 29.9793C25.3843 29.6856 25.2178 29.2872 25.2178 28.8718V20.5184C25.2178 19.6534 25.9256 18.9521 26.7988 18.9521Z",
    fill: "#007f6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6542 5.06985C19.117 5.80339 18.8919 6.76969 18.1514 7.22815L9.71904 12.449C8.97857 12.9075 8.00313 12.6845 7.54034 11.9509C7.07755 11.2174 7.30265 10.2511 8.04312 9.79263L16.4755 4.57178C17.216 4.11332 18.1914 4.33632 18.6542 5.06985Z",
    fill: "#007f6d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9454 5.06985C35.4082 4.33631 36.3837 4.11332 37.1242 4.57178L45.5565 9.79264C46.297 10.2511 46.5221 11.2174 46.0593 11.9509C45.5965 12.6845 44.621 12.9075 43.8806 12.449L35.4482 7.22815C34.7078 6.76969 34.4827 5.80338 34.9454 5.06985Z",
    fill: "#007f6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingHours);
export default __webpack_public_path__ + "static/media/working-hours.cfed588edf9ef4759857f514a909b6d3.svg";
export { ForwardRef as ReactComponent };